var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMaletin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 34H0V3H40V34Z",
    fill: "#F5BC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19H20H0V3H40V19Z",
    fill: "#EB7900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H7V22H13V19Z",
    fill: "#EB7900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19H27V22H33V19Z",
    fill: "#EB7900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H13V3H27V0Z",
    fill: "#F5BC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H7V19H13V16Z",
    fill: "#EB0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16H27V19H33V16Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaletin);
export default __webpack_public_path__ + "static/media/ic_maletin.54c24de943ca01c600a3bb8c09d0a153.svg";
export { ForwardRef as ReactComponent };